import { inject, injectable } from 'inversify';

import { UpdatorService } from '@vk-hr-tek/core/updator';
import { VersionService } from '@vk-hr-tek/core/version';
import { LocalStorage } from '@vk-hr-tek/core/local-storage';
import { Logger } from '@vk-hr-tek/core/logger';

import { setRefreshing, setServiceUnavailable } from '../../layout/slice';
import type { AppDispatch } from '../store';

@injectable()
export class AppUpdator extends UpdatorService {
  private dispatch: AppDispatch | null = null;

  constructor(
    versionService: VersionService,
    @inject(LocalStorage) localStorage: LocalStorage,
    private readonly logger: Logger,
  ) {
    super(versionService, localStorage);
  }

  /**
   * Подключить Redux dispatch для показа лоадера и страницы ошибки
   * @param dispatch - Функция dispatch Redux-стора
   */
  setDispatch(dispatch: AppDispatch) {
    this.dispatch = dispatch;
  }

  protected showLoader() {
    this.dispatch?.(setRefreshing(true));
  }

  protected hideLoader() {
    this.dispatch?.(setRefreshing(false));
  }

  protected showErrorPage() {
    this.logger.warning('[updator] Превышено количество попыток перезагрузки', {
      tags: {
        vkdoc_error_type: 'refresh_error',
      },
    });
    this.dispatch?.(setServiceUnavailable(true));
  }
}
